function Send({ ...rest }) {
  return (
    <svg
      width='21'
      height='21'
      viewBox='0 0 21 21'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...rest}
    >
      <path
        d='M0.945838 7.2169C0.423838 7.0429 0.418838 6.7619 0.955838 6.5829L20.0428 0.220896C20.5718 0.0448958 20.8748 0.340896 20.7268 0.858896L15.2728 19.9449C15.1228 20.4739 14.8178 20.4919 14.5938 19.9899L10.9998 11.9019L16.9998 3.9019L8.99984 9.9019L0.945838 7.2169Z'
        fill='white'
      />
    </svg>
  );
}

export default Send;
